import PropTypes from 'prop-types';
import { Box, Button, Card, Typography, useTheme } from '@material-ui/core';

import { PINPEO } from 'theme/palette';
import { useAggregator } from 'context/AggregatorContext';

/**
 * Estado vacío consistente del rediseño ("Selecciona un agregador").
 * Card blanco centrado con círculo de icono, título, texto y botón que
 * abre el selector de agregador del sidebar.
 */
export default function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
}) {
  const { requestSelectorOpen } = useAggregator();
  const { brand } = useTheme();

  const handleAction = onAction || requestSelectorOpen;

  return (
    <Card
      style={{
        borderRadius: PINPEO.radiusCard,
        border: `1px solid ${PINPEO.border}`,
        padding: '64px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <Box
        style={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: brand.primarySoft,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 16,
        }}
      >
        {Icon && <Icon style={{ fontSize: 26, color: brand.primary }} />}
      </Box>

      <Typography style={{ fontSize: 15, fontWeight: 700, marginBottom: 6 }}>
        {title}
      </Typography>

      {description && (
        <Typography
          style={{
            fontSize: 13,
            color: PINPEO.textSecondary,
            maxWidth: 360,
            lineHeight: 1.6,
            marginBottom: 18,
          }}
        >
          {description}
        </Typography>
      )}

      {actionLabel && (
        <Button variant="outlined" size="small" onClick={handleAction}>
          {actionLabel}
        </Button>
      )}
    </Card>
  );
}

EmptyState.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
};

EmptyState.defaultProps = {
  icon: null,
  description: '',
  actionLabel: '',
  onAction: null,
};
